import type { Fragment } from "../translations";
export const control: Fragment = {
  fr: {
    "control.category": "Catégorie",
    "control.moreCards": "Afficher les {n} autres",
    "control.collapseCards": "Réduire",
    "control.subtitle":
      "Les processus en service et le travail qui prépare leurs prochaines versions.",
    "control.board": "Tableau",
    "control.boardLandscape": "Tableau par catégorie de processus et statut",
    "control.domainsInRow": "Domaines de cette catégorie",
    "control.subdomain": "Sous-domaine",
    "control.workCount": "{n} interventions",

    "control.list": "Liste",
    "control.landscape": "Paysage",
    "control.inbox": "Inbox",
    "control.todo": "To Do",
    "control.in_progress": "In Progress",
    "control.done": "Done",
    "control.inboxHint": "Demandes à qualifier",
    "control.todoHint": "Prêtes à démarrer",
    "control.in_progressHint": "Créations et révisions en cours",
    "control.doneHint": "Versions publiées",
    "control.new": "Nouveau processus",
    "control.revision": "Révision",
    "control.creation": "Création",
    "control.client": "Client",
    "control.consultant": "Responsable CdE",
    "control.domain": "Domaine",
    "control.type": "Type de travail",
    "control.status": "Statut",
    "control.all": "Tous",
    "control.allClients": "Tous les clients",
    "control.allConsultants": "Tous les responsables CdE",
    "control.allDomains": "Tous les domaines",
    "control.qualify": "À qualifier",
    "control.unassigned": "À attribuer",
    "control.noDomain": "Domaine à préciser",
    "control.nextAction": "À faire / résultat attendu",
    "control.noAction": "Préciser la prochaine action",
    "control.editNote": "Modifier la note",
    "control.meetings": "Réunions",
    "control.nextMeeting": "Prochaine",
    "control.lastMeeting": "Dernière",
    "control.noMeetings": "Aucune réunion liée",
    "control.published": "En service",
    "control.preparing": "En préparation",
    "control.noPublished": "Aucune mise en service enregistrée",
    "control.noVersion": "Version à préciser",
    "control.noCards": "Aucune intervention dans cette colonne.",
    "control.startHint":
      "Créer un processus ou ouvrir une révision depuis le répertoire.",
    "control.boardHint":
      "Le tableau suit les interventions CdE. La Liste et le Paysage incluent aussi les définitions à qualifier.",
    "control.open": "Ouvrir la fiche",
    "control.move": "Déplacer vers",
    "control.count": "{n} processus",
    "control.reset": "Effacer les filtres",
    "control.phase": "Phase CdE",
    "control.allPhases": "Toutes les phases",
    "control.cancelled": "Annulée",
    "control.superseded": "Version précédente",
    "control.paused": "En pause",
    "control.includeClosed": "Inclure les interventions annulées",
    "control.history": "Interventions et livraisons",
    "control.work": "Travail CdE",
    "control.targetVersion": "Version à publier",
    "control.review": "Compte rendu de revue",
    "control.reviewHint":
      "Décrire ce qui a été vérifié et les décisions prises avant publication.",
    "control.impacts": "Impacts à revoir",
    "control.roles": "Rôles et responsabilités",
    "control.clientImpact": "Engagements envers le client",
    "control.kpis": "KPIs et dashboards",
    "control.systems": "Systèmes",
    "control.approve": "Valider la revue",
    "control.reviewed": "Validé par {name}",
    "control.reviewPending": "Revue attendue",
    "control.publish": "Publier la version",
    "control.publishConfirm":
      "Publier cette version après revue ? La version actuelle restera accessible dans l’historique.",
    "control.publicationSaved": "Version publiée.",
    "control.pause": "Mettre en pause",
    "control.resume": "Reprendre",
    "control.pauseReason": "Motif de la pause",
    "control.fullCycle": "Cycle complet de huit phases",
    "control.lightRevision": "Révision simple",
    "control.mode": "Parcours de la révision",
    "control.modeReason": "Motif du choix de parcours",
    "control.changeMode": "Appliquer le parcours",
    "control.saved": "Enregistré",
    "control.error": "Le travail n’a pas pu être chargé.",
    "control.meetingTitle": "Titre de la réunion",
    "control.meetingDate": "Date et heure",
    "control.participants": "Participants",
    "control.minutes": "Compte rendu et décisions",
    "control.recording": "Enregistrement",
    "control.addMeeting": "Ajouter une réunion",
    "control.held": "Réunion tenue",
    "control.scheduled": "À venir",
    "control.pastEvent": "Rendez-vous passé",
    "control.documented": "Réunion documentée",
    "control.confirmHeld": "Confirmer la tenue",
    "control.transcript": "Transcription",
    "control.join": "Rejoindre",
    "control.sync": "Actualiser les réunions",
    "control.syncHint":
      "Ajouter {code} au titre du rendez-vous ou de l’enregistrement pour le rattacher au processus.",
    "control.calendar": "Calendrier Microsoft 365",
    "control.speakr": "Speakr",
    "control.notConfigured": "Connexion à configurer",
    "control.imported": "{n} réunions synchronisées",
    "control.linkSpeakr": "Lier mon compte Speakr",
    "control.token": "Jeton personnel Speakr",
    "control.shared": "Partagée avec le CdE",
    "control.private": "Visible par vous uniquement",
    "control.shareMeeting": "Partager cette réunion",
    "control.association": "Intervention liée",
    "control.unlinked": "À associer à une intervention",
    "control.meetingHistory": "Toutes les réunions du processus",
    "control.notes": "Notes et décisions",
    "control.addNote": "Ajouter une note",
    "control.noteBody": "Note de travail",
    "control.emptyNotes": "Aucune note pour cette intervention.",
    "control.noHistory": "Aucune intervention précédente.",
    "control.reviewOwner":
      "Les rôles sont validés par la gouvernance ; les autres impacts par le CdE.",
    "control.qualificationHint":
      "Renseigner le client, le responsable CdE, le domaine et le résultat attendu avant de passer en To Do.",
  },
  en: {},
};
